<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-form
            v-model="valid"
            lazy-validation
            ref="form"
            id="new-patient-form">
    <v-layout
      justify-center
      wrap
    >

      <v-flex
        xs12
        md8
      >

        <material-card
          color="green"
          title="إضافة مستخدم جديد"
          text="يرجى ادخال معلومات المستخدم وتحديد الصلاحيات و كلمة السر الخاصه للدخول الى النظام"
        >

            <v-container py-0>
              <v-layout wrap>

                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                          clearable
                          autocomplete="new-user"
                    v-model="username"
                    class="purple-input"
                    required
                    :rules="usernameRule"
                    label="إسم المستخدم"

                  />
                </v-flex>
                  <v-flex
                          xs12
                          md6
                  >
                      <v-text-field
                              clearable
                              v-model="password"
                              type="password"
                              class="purple-input"
                              required
                              autocomplete="new-password"
                              :rules="passwordRule"
                              label="كلمة السر"

                      />
                  </v-flex>

                  <v-flex
                          xs12
                          md4
                  >
                      <v-text-field
                              v-model="fullname"
                              required
                              :rules="nameRules"
                              label="إسم المستخدم الثلاثي"

                      />
                  </v-flex>

                  <v-flex
                          xs12
                          md4>
                      <v-combobox
                              :items="this.$store.state.iraqprovs"
                              v-model="province"
                              item-text="text"
                              label="المحافظة"
                              return-object
                      ></v-combobox>

                  </v-flex>

               <v-flex
                   xs12
                   md4>
                   <v-combobox
                           :items="healthdeps"
                           v-model="healthdep"
                           item-text="text"
                           label="دائرة الصحة"
                           return-object
                   ></v-combobox>

                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="healthsector"
                    label="القطاع"
                    class="purple-input"
                     :ruls="nameRules"
                    required
                    />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                  v-model="healthcenter"
                    label="المركز الصحي"
                    class="purple-input"
                     :ruls="nameRules"
                    required/>
                </v-flex>

                <v-flex
                  xs12
                  md4
                >

                <v-text-field
                  v-model="jobtitle"
                    label="العنوان الوظيفي"
                    class="purple-input"
                     :ruls="nameRules"
                    required/>
                </v-flex>

                <v-flex
                  xs12
                  md4>
                  <v-combobox
                    v-model="profileid"
                    item-text="text"
                    :items="profiles"
                    label="صنف الصلاحيات"
                  ></v-combobox>
                </v-flex>
                  <v-flex
                          xs12
                          md4>
                      <v-combobox
                              v-model="groupid"
                              item-text="text"
                              :items="groups"
                              label="المجموعة"
                      ></v-combobox>
                  </v-flex>



              </v-layout>
            </v-container>

        </material-card>
      </v-flex>
          <v-flex
                  class="bluegray"
                  md12
                  xs12
                  text-xs-right
                    >



                      <v-btn
                              @click="validateFunc"
                              :disabled="!valid"
                              form="new-patient-form"
                              class="mx-0 font-weight-bold"
                              color="success"
                      >
                          إضافة المستخدم
                      </v-btn>






          </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>

import {__HTTP,FormHeader} from '@/utils/utils'
  export default {
 
    data: () => ({
        valid: true,
        usernameRule: [
            v => !!v || 'هذا الحقل مطلوب',
            v => v.length > 2 || 'الحروف المدخلة قليلة',
        ],
        passwordRule: [
            v => !!v || 'هذا الحقل مطلوب',
            v => v.length > 8 || 'الحروف المدخلة قليلة',
        ],
        nameRules: [
        v => !!v || 'هذا الحقل مطلوب',
        v => v.length > 1 || 'الحروف المدخلة قليلة',
        ],
        emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
        ],
        username: '',
        fullname: '',
        password: '',
        healthsector: '',
        healthdep: '',
        province: '',
        healthcenter: '',
        jobtitle: '',
        profileid: '',
        groupid: '',
        groups: [],
        healthdeps: [],
        profiles: [],
    }),
    created() { 
      this.getGroups();
      this.getProfiles();
      this.getHealthDeps();
      },
    methods: {
      getHealthDeps() {
         __HTTP("?do=gethealthdeps",{},FormHeader,(res) => {
              res.map((i) => {
                this.healthdeps.push({
                  text: i.title,
                  value: i.id
                });
              });
              
              // return x;
          });
      },
    getGroups() {
      __HTTP("?do=getgroups",{},FormHeader,(res) => {
              res.map((i) => {
                this.groups.push({
                  text: i.title,
                  value: i.id
                });
              });

          });
    },
        getProfiles() {
            __HTTP("?do=getonlyprofiles",{},FormHeader,(res) => {
                res.map((i) => {
                    this.profiles.push({
                        text: i.title,
                        value: i.id
                    });
                });

            });
        },
      validateFunc() {
        if (this.$refs.form.validate()) {
          this.submitForm()
        }
      },
      submitForm() {
        __HTTP("?do=newusers",{
          username: this.username,
          password: this.password,
          fullname: this.fullname,
          healthdep: this.healthdep.value,
          healthsector: this.healthsector,
          healthcenter: this.healthcenter,
          province: this.province.value,
          jobtitle: this.jobtitle,
          profileid: this.profileid.value,
          groupid: this.groupid.value
        },FormHeader,(res) => {
          console.log(res);
              if (res.auth == true) {
                this.$router.push({path: '/list-users'})
              } else {
                alert("حصل خلل بالعملية");
              }

        }
        )

      }
    }
  }
</script>

